module.exports = "<img *ngIf=\"loading\" src=\"assets/images/loading.gif\" alt=\"loading\" />\n\n<img *ngIf=\"!displayMode\"\n\t[hidden]=\"loading\" (load)=\"onLoad()\" (error)=\"onLoad()\"\n\t[src]=\"getUrlAnexo(this.docuwareID) | useHttpImgSrc\" alt=\"\" style=\"cursor:pointer;\"\n\t(click)=\"openImgNewWindow(this.docuwareID)\"/>\n\n<img *ngIf=\"displayMode\"\n\t[hidden]=\"loading\" (load)=\"onLoad()\" (error)=\"onLoad()\"\n\t[src]=\"getUrlAnexo(this.docuwareID) | useHttpImgSrc\" alt=\"\"/>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/img-docuware/img-docuware.component.html
// module id = ./src/app/components/img-docuware/img-docuware.component.html
// module chunks = main